import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=be05354a"
import script from "./spinner.js?vue&type=script&lang=js&external"
export * from "./spinner.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports